import type { LaundryModificationRequest, LaundryProfile } from '@/types';

/**
 * Demo approved profile for the signed-in laundry (FB10). The dashboard always
 * shows these approved values first; a pending modification never replaces them
 * until the admin approves it. Replaced by the settings API later.
 */
export const laundryProfile: LaundryProfile = {
  name: 'مغسلة لاوندري بوكس - النخيل',
  description:
    'مغسلة حديثة تقدم خدمات الغسيل والكوي للقطع اليومية والملابس الرسمية، مع استلام وتوصيل عبر مندوبين تابعين وتحسين جودة التنظيف للبقع الصعبة.',
  logoUrl:
    'https://readdy.ai/api/search-image?query=Clean%20modern%20laundry%20service%20emblem%20with%20soft%20folded%20towels%20on%20a%20plain%20light%20background%2C%20minimal%20editorial%20product%20photography%2C%20centered%20composition&width=400&height=400&seq=lb-laundry-logo-nakheel&orientation=squarish',
  phone: '0551234567',
  address: {
    cityId: 'riyadh',
    district: 'النخيل',
    street: 'شارع الأمير سلطان بن عبدالعزيز',
    building: '12',
  },
  coverageDistricts: ['النخيل', 'الياسمين', 'العقيق', 'حطين'],
  fromTime: '08:00',
  toTime: '23:00',
  normalHours: 48,
  urgentHours: 24,
};

/**
 * Preview modification requests used to expose the admin-decision states in the
 * demo. Real states come from the system; these examples let the design be
 * reviewed without owner-controlled approve/reject buttons.
 */
const proposedProfile: LaundryProfile = {
  name: 'مغسلة لاوندري بوكس - الياسمين',
  description:
    'مغسلة حديثة تقدم خدمات الغسيل والكوي للقطع اليومية والملابس الرسمية، مع استلام وتوصيل عبر مندوبين تابعين، وأقسام مخصصة للتنظيف الجاف والعناية بالأقمشة الحساسة.',
  logoUrl: laundryProfile.logoUrl,
  phone: '0559998877',
  address: {
    cityId: 'riyadh',
    district: 'الياسمين',
    street: 'شارع التخصصي',
    building: '245',
  },
  coverageDistricts: ['الياسمين', 'العقيق', 'حطين', 'الملقا'],
  fromTime: '09:00',
  toTime: '22:30',
  normalHours: 36,
  urgentHours: 12,
};

export const previewModifications: Record<
  'under_review' | 'approved' | 'rejected',
  LaundryModificationRequest
> = {
  under_review: {
    id: 'MOD-2041',
    status: 'under_review',
    submittedAt: '2026-10-09T14:20:00',
    rejectionReason: null,
    previous: laundryProfile,
    proposed: proposedProfile,
  },
  approved: {
    id: 'MOD-2038',
    status: 'approved',
    submittedAt: '2026-10-05T10:05:00',
    rejectionReason: null,
    previous: laundryProfile,
    proposed: proposedProfile,
  },
  rejected: {
    id: 'MOD-2035',
    status: 'rejected',
    submittedAt: '2026-10-02T09:40:00',
    rejectionReason:
      'صورة الشعار المرفقة منخفضة الجودة وغير واضحة، كما أن تغيير أوقات العمل إلى 22:30 لا يتوافق مع بيانات التغطية المعتمدة لبعض الأحياء المطلوبة. يرجى إعادة تقديم الطلب مع شعار بجودة أعلى وتوضيح أوقات العمل المرغوبة.',
    previous: laundryProfile,
    proposed: proposedProfile,
  },
};